module.exports = __webpack_public_path__ + "static/media/isolamentoSocial.266fdb43.svg";